import { useState } from 'react'

// Navegacao por teclado (seta pra cima/baixo + Enter) numa lista de sugestoes de autocomplete.
// `total` e o tamanho da lista atual (recalculado a cada render, pode mudar com a digitacao) e
// `aoSelecionar(indice)` e chamado quando o usuario confirma com Enter.
export function useNavegacaoLista(total, aoSelecionar) {
  const [indice, setIndice] = useState(-1)

  const onKeyDown = (e) => {
    if (!total) return
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setIndice(i => (i + 1) % total)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setIndice(i => (i <= 0 ? total - 1 : i - 1))
    } else if (e.key === 'Enter') {
      if (indice >= 0 && indice < total) {
        e.preventDefault()
        aoSelecionar(indice)
        setIndice(-1)
      }
    } else if (e.key === 'Escape') {
      setIndice(-1)
    }
  }

  return { indice, onKeyDown, reset: () => setIndice(-1), setIndice }
}
